// extracted by mini-css-extract-plugin
module.exports = {"SnippetCarouselItem":"snippet-carousel-item_SnippetCarouselItem__PC_m_"};